module.exports = __webpack_public_path__ + "assets/certificate_pdf/Web Design Using HTML5_Silicon Stone Education_2019-10-04.15a52162.pdf";